import { useMutation } from '@apollo/client';
import Gleap from 'gleap';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import { LOGOUT_USER } from './graphql/Mutations';

const Logout = () => {
  const { dispatch } = useContext(AppContext);
  const [logout, { loading, error, data }] = useMutation(LOGOUT_USER, {
    onError() {},
  });

  useEffect(() => {
    logout();
  }, []);

  Gleap.clearIdentity();

  if (loading) return <LoaderComponent />;

  if (error) {
    dispatch({ type: 'LOGOUT' });
    // eslint-disable-next-line no-undef
    if (window.self !== window.top) {
      // Inside an iframe, update only the iframe's location
      // eslint-disable-next-line no-undef
      window.frameElement.src = ROUTES.LOGIN;
    } else {
      // Outside an iframe, redirect the whole site
      // eslint-disable-next-line no-undef
      window.top.location.replace(ROUTES.LOGIN);
    }

    return null;
  }

  if (data) {
    dispatch({ type: 'LOGOUT' });
    // eslint-disable-next-line no-undef
    if (window.self !== window.top) {
      // Inside an iframe, update only the iframe's location
      // eslint-disable-next-line no-undef
      window.frameElement.src = ROUTES.LOGIN;
    } else {
      // Outside an iframe, redirect the whole site
      // eslint-disable-next-line no-undef
      window.top.location.replace(ROUTES.LOGIN);
    }
    return null;
  }

  return null;
};

export default Logout;
